// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p2UVB","clinicsSelect":"styles_clinicsSelect__2SznS"};